<template>
  <section class="cashier-history-wrapper">
    <b-card no-body>
      <div class="m-2">
        <b-row>
          <b-col md="12">
            <div class="d-flex align-items-center justify-content-between">
              <h2>{{ $t("cashiers.history-title") }}</h2>
              <b-button
                variant="outline-secondary"
                size="sm"
                @click="$router.push({ name: 'cashiers-history' })"
              >
                <feather-icon
                  icon="ArrowLeftIcon"
                  class="mr-1"
                  size="14"
                />
                {{ $t("cashiers.back-to-list") }}
              </b-button>
            </div>
          </b-col>
          <b-col
            cols="12"
            md="12"
          >
            <br>
          </b-col>
          <b-col
            md="2"
            cols="12"
          >
            <b-form-group
              label="القبض من"
              label-for="from-date"
            >
              <datepicker
                id="from-date"
                v-model="fromDate"
                :calendar-button="true"
                :clear-button="true"
                :bootstrap-styling="true"
                class="datebtn2"
                placeholder="YYYY-MM-DD"
              />
            </b-form-group>
          </b-col>
          <b-col
            md="2"
            cols="12"
          >
            <b-form-group
              label="القبض الى"
              label-for="to-date"
            >
              <datepicker
                id="to-date"
                v-model="toDate"
                :calendar-button="true"
                :clear-button="true"
                :bootstrap-styling="true"
                class="datebtn2"
                placeholder="YYYY-MM-DD"
              />
            </b-form-group>
          </b-col>
          <b-col
            md="2"
            cols="12"
          >
            <b-form-group
              label="الكشف من"
              label-for="paid-from-date"
            >
              <datepicker
                id="paid-from-date"
                v-model="paidFromDate"
                :calendar-button="true"
                :clear-button="true"
                :bootstrap-styling="true"
                class="datebtn2"
                placeholder="YYYY-MM-DD"
              />
            </b-form-group>
          </b-col>
          <b-col
            md="2"
            cols="12"
          >
            <b-form-group
              label="الكشف الى"
              label-for="paid-to-date"
            >
              <datepicker
                id="paid-to-date"
                v-model="paidToDate"
                :calendar-button="true"
                :clear-button="true"
                :bootstrap-styling="true"
                class="datebtn2"
                placeholder="YYYY-MM-DD"
              />
            </b-form-group>
          </b-col>
          <b-col
            md="2"
            cols="12"
          >
            <b-form-group
              :label="$t('common.invoice-number')"
              label-for="invoice-number-filter"
            >
              <b-form-input
                id="invoice-number-filter"
                v-model.trim="filterInvoiceNumber"
                :placeholder="$t('common.invoice-number')"
                @keyup.enter="fetchHistory()"
              />
            </b-form-group>
          </b-col>
          <b-col
            v-if="false"
            md="2"
            cols="12"
          >
            <b-form-group
              :label="$t('common.status')"
              label-for="status"
            >
              <v-select
                id="status"
                v-model="status"
                :options="statusOptions"
                :clearable="true"
                placeholder="All Statuses"
              />
            </b-form-group>
          </b-col>
          <b-col
            md="2"
            cols="12"
          >
            <b-form-group
              label="نوع الخدمة"
              label-for="service-type-filter"
            >
              <v-select
                id="service-type-filter"
                v-model="filterServiceType"
                :options="serviceTypeFilterOptions"
                label="text"
                :reduce="option => option.value"
                :clearable="true"
                placeholder="نوع الخدمة"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="2"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <b-button
              class="mt-50"
              variant="primary"
              @click="fetchHistory()"
            >
              {{ $t("common.search") }}
              <feather-icon
                icon="SearchIcon"
                class="ml-1"
                size="16"
              />
            </b-button>
          </b-col>
          <b-col
            cols="12"
            md="2"
            class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
          >
            <!-- <b-button
              v-if="invoices.length > 0"
              class="mt-50"
              variant="outline-primary"
              @click="exportToCSV()"
            >
              {{ $t("common.export-excel") }}
              <feather-icon icon="DownloadIcon" class="ml-1" size="16" />
            </b-button> -->
          </b-col>
        </b-row>
        <!-- Totals Summary -->
        <b-row
          v-if="hasSummaryData"
          class="mt-3"
        >
          <b-col cols="12">
            <b-card class="totals-summary-card mb-3">
              <b-card-body>
                <b-row class="totals-summary-row text-center d-flex justify-content-between flex-wrap">
                  <b-col
                    md="2"
                    cols="6"
                    class="mb-3 mb-md-0"
                  >
                    <div class="total-item">
                      <div class="total-icon-wrapper info">
                        <feather-icon
                          icon="FileTextIcon"
                          size="24"
                        />
                      </div>
                      <h6 class="total-label mt-2 mb-1">
                        {{ $t("common.total-invoices") || "Total Invoices" }}
                      </h6>
                      <div class="total-value info-text">
                        {{ sums.count }}
                      </div>
                    </div>
                  </b-col>
                  <b-col
                    md="2"
                    cols="6"
                    class="mb-3 mb-md-0"
                  >
                    <div class="total-item">
                      <div class="total-icon-wrapper secondary">
                        <feather-icon
                          icon="DollarSignIcon"
                          size="24"
                        />
                      </div>
                      <h6 class="total-label mt-2 mb-1">
                        {{ $t("common.total-amount") || "Total Amount" }}
                      </h6>
                      <div class="total-value secondary-text">
                        {{ formatAmount(sums.total_amount) }}
                      </div>
                    </div>
                  </b-col>
                  <b-col
                    md="2"
                    cols="6"
                    class="mb-3 mb-md-0"
                  >
                    <div class="total-item">
                      <div class="total-icon-wrapper warning">
                        <feather-icon
                          icon="TagIcon"
                          size="24"
                        />
                      </div>
                      <h6 class="total-label mt-2 mb-1">
                        {{ $t("common.total-discount") || "Total Discount" }}
                      </h6>
                      <div class="total-value warning-text">
                        {{ formatAmount(sums.total_discount) }}
                      </div>
                    </div>
                  </b-col>
                  <b-col
                    md="2"
                    cols="6"
                    class="mb-3 mb-md-0"
                  >
                    <div class="total-item">
                      <div class="total-icon-wrapper danger">
                        <feather-icon
                          icon="RotateCcwIcon"
                          size="24"
                        />
                      </div>
                      <h6 class="total-label mt-2 mb-1">
                        الاسترداد
                      </h6>
                      <div class="total-value danger-text">
                        {{ formatAmount(refunds.total_refund_amount) }}
                      </div>
                      <small class="text-muted">
                        {{ refunds.refund_count }} {{ $t("common.total-invoices") || "invoice(s)" }}
                      </small>
                    </div>
                  </b-col>
                  <b-col
                    md="2"
                    cols="6"
                  >
                    <div class="total-item">
                      <div class="total-icon-wrapper success">
                        <feather-icon
                          icon="CheckCircleIcon"
                          size="24"
                        />
                      </div>
                      <h6 class="total-label mt-2 mb-1">
                        {{ $t("common.net-amount") || "Net Amount" }}
                      </h6>
                      <div class="total-value success-text">
                        {{ formatAmount(adjustedNetAmount) }}
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col>
            <b-table
              v-if="!loading"
              :items="preparedInvoices"
              responsive
              :fields="tableColumns"
              primary-key="invoiceId"
              class="position-relative"
              show-empty
              :empty-text="$t('common.no-invoices-found')"
            >
              <template #cell(type)="data">
                <div>
                  <span class="text-nowrap">{{
                    formatInvoiceType(data.item.type)
                  }}</span>
                  <div
                    v-if="
                      data.item.serviceTitle || data.item.serviceTypeName
                    "
                    class="  mt-1"
                  >
                    <span v-if="data.item.serviceTitle">{{
                      data.item.serviceTitle
                    }}</span>
                    <span
                      v-if="
                        data.item.serviceTitle && data.item.serviceTypeName
                      "
                    >
                      ·
                    </span>
                    <span v-if="data.item.serviceTypeName">{{
                      data.item.serviceTypeName
                    }}</span>
                  </div>
                </div>
              </template>
              <template #cell(number)="data">
                <span class="text-nowrap">{{ data.item.number }}</span>
              </template>
              <template #cell(patientName)="data">
                <span>{{ data.item.patientName }}</span>
              </template>
              <template #cell(itemTitle)="data">
                <span>{{ data.item.itemTitle }}</span>
              </template>
              <template #cell(amount)="data">
                <span class="font-weight-bold">{{
                  formatAmount(data.item.amount, data.item.currency)
                }}</span>
              </template>
              <template #cell(discount)="data">
                <span>{{
                  formatAmount(data.item.discount || 0, data.item.currency)
                }}</span>
              </template>
              <template #cell(status)="data">
                <b-badge
                  :variant="
                    data.item.status === 'approved'
                      ? 'success'
                      : data.item.status === 'pending'
                        ? 'warning'
                        : 'secondary'
                  "
                >
                  {{ data.item.status }}
                </b-badge>
              </template>
              <template #cell(paidBy)="data">
                <div v-if="data.item.paidBy">
                  <div class="font-weight-bold">
                    {{ data.item.paidBy.name || "-" }}
                  </div>
                </div>
                <span v-else>-</span>
              </template>
              <template #cell(paidDate)="data">
                <span class="text-nowrap">{{
                  formatDate(data.item.paidDate)
                }}</span>
              </template>
              <template #cell(createdBy)="data">
                <span>{{ data.item.createdBy || "-" }}</span>
              </template>
              <template #cell(createdAt)="data">
                <span class="text-nowrap">{{
                  formatDate(data.item.createdAt)
                }}</span>
              </template>
            </b-table>
            <template v-if="loading">
              <div>
                <div class="d-flex justify-content-center mb-1">
                  <b-spinner label="Loading..." />
                </div>
              </div>
            </template>
          </b-col>
        </b-row>
      </div>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted mr-2">
              {{ $t("common.showing") }}
              {{ (pagination.page - 1) * pagination.pageSize + 1 }}
              {{ $t("common.to") }}
              {{
                Math.min(
                  pagination.page * pagination.pageSize,
                  pagination.total
                )
              }}
              {{ $t("common.of") || "of" }} {{ pagination.total }}
            </span>
            <b-form-select
              v-model="pagination.pageSize"
              :options="pageSizeOptions"
              size="sm"
              style="width: auto; min-width: 80px"
              class="ml-2"
              @change="onPageSizeChange"
            />
          </b-col>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="pagination.page"
              :total-rows="pagination.total"
              :per-page="pagination.pageSize"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </section>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BTable,
  BButton,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BPagination,
  BSpinner,
  BBadge,
} from 'bootstrap-vue'
import Datepicker from 'vuejs-datepicker'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  name: 'CashierHistory',
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BTable,
    BButton,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BPagination,
    BSpinner,
    BBadge,
    Datepicker,
    vSelect,
  },
  data() {
    return {
      cashierId: null,
      fromDate: null,
      toDate: null,
      paidFromDate: null,
      paidToDate: null,
      status: null,
      filterInvoiceNumber: '',
      filterServiceType: null,
      serviceTypeOptions: [],
      statusOptions: ['pending', 'approved', 'rejected', 'printed'],
      loading: false,
      invoices: [],
      sums: {
        total_amount: 0,
        total_discount: 0,
        net_amount: 0,
        count: 0,
      },
      refunds: {
        total_refund_amount: 0,
        refund_count: 0,
      },
      pagination: {
        page: 1,
        pageSize: 15,
        total: 0,
      },
      pageSizeOptions: [
        { value: 10, text: '10' },
        { value: 15, text: '15' },
        { value: 25, text: '25' },
        { value: 50, text: '50' },
        { value: 100, text: '100' },
      ],
    }
  },
  computed: {
    tableColumns() {
      return [
        { key: 'type', label: this.$t('common.type'), sortable: true },
        {
          key: 'number',
          label: this.$t('common.invoice-number'),
          sortable: true,
        },

        {
          key: 'patientName',
          label: this.$t('reception.patient-name'),
          sortable: false,
        },
        {
          key: 'itemTitle',
          label: this.$t('hospital.service'),
          sortable: false,
        },
        { key: 'amount', label: this.$t('common.amount'), sortable: true },
        { key: 'discount', label: this.$t('common.discount'), sortable: true },
        // { key: "status", label: this.$t("common.status"), sortable: true },
        {
          key: 'paidBy',
          label: 'القابض',
          sortable: false,
        },
        {
          key: 'paidDate',
          label: 'تاريخ الاستلام',
          sortable: true,
        },
        {
          key: 'createdBy',
          label: 'المنشئ',
          sortable: false,
        },
        {
          key: 'createdAt',
          label: 'تاريخ الإنشاء',
          sortable: true,
        },
      ]
    },
    serviceTypeFilterOptions() {
      const options = [{ value: null, text: this.$t('common.all') }]
      this.serviceTypeOptions.forEach(st => {
        options.push({
          value: st.id,
          text: st.name,
        })
      })
      return options
    },
    preparedInvoices() {
      if (!Array.isArray(this.invoices)) return []
      return this.invoices.map(raw => ({
        invoiceId: raw.id,
        type: raw.type,
        number: raw.invoice_no,
        patientName:
          (raw.patientCard
            && raw.patientCard.patient
            && raw.patientCard.patient.name)
          || (raw.patient_card
            && raw.patient_card.patient
            && raw.patient_card.patient.name)
          || '-',
        itemTitle:
          (raw.service && raw.service.title)
          || (raw.surgery && raw.surgery.title)
          || '-',
        serviceTitle: (raw.service && raw.service.title) || null,
        serviceTypeName:
          (raw.service
            && raw.service.type
            && raw.service.type.name)
          || null,
        amount: raw.amount,
        discount: raw.discount || 0,
        currency: raw.currency || 'IQD',
        status: raw.status,
        paidBy: raw.approved_by || null,
        paidDate: raw.approved_at || null,
        createdAt: raw.created_at,
        createdBy:
          (raw.created_by && raw.created_by.name)
          || (raw.createdBy && raw.createdBy.name)
          || '-',
      }))
    },
    adjustedNetAmount() {
      return Number(this.sums.net_amount || 0) - Number(this.refunds.total_refund_amount || 0)
    },
    hasSummaryData() {
      return Number(this.sums.count || 0) > 0
        || Number(this.refunds.refund_count || 0) > 0
        || Number(this.refunds.total_refund_amount || 0) > 0
    },
  },
  watch: {
    'pagination.page': function () {
      this.fetchHistory()
    },
    '$route.params.cashierId': function (newId) {
      this.cashierId = newId
      this.fetchHistory()
    },
    filterServiceType() {
      if (this.pagination.page !== 1) {
        this.pagination.page = 1
        return
      }
      this.fetchHistory()
    },
  },
  mounted() {
    this.cashierId = this.$route.params.cashierId
    this.loadServiceTypes()
    this.fetchHistory()
  },
  methods: {
    async fetchHistory() {
      if (!this.cashierId) return
      this.loading = true
      try {
        let url = `invoices/cashier/${this.cashierId}/all?page=${this.pagination.page}&take=${this.pagination.pageSize}&sort=-id&include=patientCard,paidBy,createdBy`
        if (this.filterServiceType) {
          url += `&filter[service_type_id]=${this.filterServiceType}`
        }
        if (this.fromDate) {
          const fromDateFormatted = this.formatDateWithTime(
            this.fromDate,
            false,
          )
          url += `&from=${encodeURIComponent(fromDateFormatted)}`
        }
        if (this.toDate) {
          const toDateFormatted = this.formatDateWithTime(this.toDate, true)
          url += `&to=${encodeURIComponent(toDateFormatted)}`
        }
        if (this.status) {
          url += `&status=${this.status}`
        }
        if (this.filterInvoiceNumber && this.filterInvoiceNumber.trim()) {
          url += `&filter[invoice_no]=${encodeURIComponent(this.filterInvoiceNumber.trim())}`
        }
        if (this.paidFromDate) {
          const paidFromDateFormatted = this.formatDateWithTime(
            this.paidFromDate,
            false,
          )
          url += `&paid_from=${encodeURIComponent(paidFromDateFormatted)}`
        }
        if (this.paidToDate) {
          const paidToDateFormatted = this.formatDateWithTime(
            this.paidToDate,
            true,
          )
          url += `&paid_to=${encodeURIComponent(paidToDateFormatted)}`
        }
        await this.getList(url)
        if (this.all_data) {
          // Handle nested data structure
          let rows = []
          if (Array.isArray(this.all_data.data)) {
            rows = this.all_data.data
          } else if (Array.isArray(this.all_data)) {
            rows = this.all_data
          }
          this.invoices = rows

          // Handle nested pagination structure
          if (this.all_data.pagination) {
            this.pagination.page = this.all_data.pagination.current_page || 1
            this.pagination.pageSize = this.all_data.pagination.per_page || this.pagination.pageSize
            this.pagination.total = this.all_data.pagination.total || 0
          } else if (
            this.all_data.current_page
            || this.all_data.per_page
            || this.all_data.total
          ) {
            this.pagination.page = this.all_data.current_page || 1
            this.pagination.pageSize = this.all_data.per_page || this.pagination.pageSize
            this.pagination.total = this.all_data.total || 0
          } else if (this.all_data.meta) {
            this.pagination.page = this.all_data.meta.page || 1
            this.pagination.pageSize = this.all_data.meta.take
              || this.all_data.meta.pageSize
              || this.pagination.pageSize
            this.pagination.total = this.all_data.meta.total || 0
          }

          // Handle sums/totals
          if (this.all_data.sums) {
            this.sums = {
              total_amount: this.all_data.sums.total_amount || 0,
              total_discount: this.all_data.sums.total_discount || 0,
              net_amount: this.all_data.sums.net_amount || 0,
              count: this.all_data.sums.count || 0,
            }
          } else {
            // Reset sums if not provided
            this.sums = {
              total_amount: 0,
              total_discount: 0,
              net_amount: 0,
              count: 0,
            }
          }

          if (this.all_data.refunds) {
            this.refunds = {
              total_refund_amount: this.all_data.refunds.total_refund_amount || 0,
              refund_count: this.all_data.refunds.refund_count || 0,
            }
          } else {
            this.refunds = {
              total_refund_amount: 0,
              refund_count: 0,
            }
          }
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('common.error'),
            icon: 'AlertCircleIcon',
            variant: 'danger',
            text:
              error.response?.data?.message
              || this.$t('cashiers.failed-fetch-history'),
          },
        })
      } finally {
        this.loading = false
      }
    },
    onPageSizeChange() {
      this.pagination.page = 1
      this.fetchHistory()
    },
    async loadServiceTypes() {
      try {
        await this.getList('serviceTypes?page=1&take=10&sort=-id')
        const rows = Array.isArray(this.all_data?.data)
          ? this.all_data.data
          : []
        this.serviceTypeOptions = rows.map(r => ({
          id: r.id,
          name: r.name,
        }))
      } catch (e) {
        this.serviceTypeOptions = []
      }
    },
    formatAmount(amount, currency = 'IQD') {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency,
      }).format(amount)
    },
    formatDate(dateString) {
      if (!dateString) return '-'
      const date = new Date(dateString)
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    },
    formatInvoiceType(type) {
      if (!type) return '-'
      const formattedKey = type
        .split('_')
        .map(w => w.charAt(0).toUpperCase() + w.slice(1))
        .join(' ')
      const typeMap = {
        invoice_out_clinic: 'cashiers.invoice-type-out-clinic',
        invoice_nicu: 'cashiers.invoice-type-nicu',
        invoice_patient_card_test: 'cashiers.invoice-type-patient-card-test',
        refund: 'cashiers.invoice-type-refund',
        invoice_insurance_surgery: 'cashiers.invoice-type-insurance-surgery',
        invoice_emergency: 'cashiers.invoice-type-emergency',
      }
      const key = typeMap[type]
      if (key) {
        const t = this.$t(key)
        if (t && t !== key) return `${t} (${formattedKey})`
      }
      return formattedKey
    },
    exportToCSV() {
      if (this.invoices.length === 0) return
      const headers = [
        'Number',
        'Patient',
        'Amount',
        'Currency',
        'Status',
        'Created At',
      ]
      const rows = this.invoices.map(inv => [
        inv.number,
        inv.patient,
        inv.amount,
        inv.currency || 'USD',
        inv.status || 'N/A',
        this.formatDateForCSV(inv.createdAt),
      ])
      const csvContent = [headers, ...rows]
        .map(row => row.map(cell => `"${cell}"`).join(','))
        .join('\n')
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      const url = URL.createObjectURL(blob)
      link.setAttribute('href', url)
      link.setAttribute(
        'download',
        `cashier-${this.cashierId}-invoices-${
          new Date().toISOString().split('T')[0]
        }.csv`,
      )
      link.style.visibility = 'hidden'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    formatDateForAPI(date) {
      if (!date) return null
      if (typeof date === 'string') return date
      const d = new Date(date)
      return d.toISOString().split('T')[0]
    },
    formatDateWithTime(date, isEndOfDay = false) {
      if (!date) return null
      const d = new Date(date)
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')

      if (isEndOfDay) {
        // Last second of the day: 23:59:59
        return `${year}-${month}-${day} 23:59:59`
      }
      // First second of the day: 00:00:00 (midnight)
      return `${year}-${month}-${day} 00:00:00`
    },
    formatDateForCSV(dateString) {
      if (!dateString) return ''
      const date = new Date(dateString)
      return date.toISOString()
    },
  },
}
</script>

<style scoped>
.text-nowrap {
  white-space: nowrap;
}

.totals-summary-card {
  border: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
}

.total-item {
  padding: 1rem;
  transition: transform 0.2s ease;
  min-width: 180px;
}

.total-item:hover {
  transform: translateY(-2px);
}

.total-icon-wrapper {
  width: 60px;
  height: 60px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.total-icon-wrapper.info {
  background: linear-gradient(135deg, #17a2b8 0%, #138496 100%);
  color: white;
}

.total-icon-wrapper.secondary {
  background: linear-gradient(135deg, #6c757d 0%, #5a6268 100%);
  color: white;
}

.total-icon-wrapper.warning {
  background: linear-gradient(135deg, #ffc107 0%, #e0a800 100%);
  color: white;
}

.total-icon-wrapper.success {
  background: linear-gradient(135deg, #28a745 0%, #218838 100%);
  color: white;
}

.total-icon-wrapper.danger {
  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
  color: white;
}

.total-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.total-value {
  font-size: 1.3rem;
  font-weight: 700;
  margin-top: 0.5rem;
  line-height: 1.2;
  white-space: nowrap;
}

.totals-summary-row > [class*='col-'] {
  flex: 1 1 180px;
  max-width: 220px;
}

.total-value.info-text {
  color: #17a2b8;
}

.total-value.secondary-text {
  color: #6c757d;
}

.total-value.warning-text {
  color: #ffc107;
}

.total-value.success-text {
  color: #28a745;
}

.total-value.danger-text {
  color: #dc3545;
}

@media (max-width: 768px) {
  .total-icon-wrapper {
    width: 50px;
    height: 50px;
  }

  .total-label {
    font-size: 0.75rem;
  }
}
</style>
